import moment from "moment";
import {
  CreateLiveEventActions,
  CreateLiveEventState,
  CreateLiveEventSteps,
} from "./types";

export const initialCreateLiveEventState: CreateLiveEventState = {
  currentCreateLiveEventStep: "basicForm",
  formData: {
    bookingQuestions: [],
    callLocation: "video",
    callPrice: 100,
    callPriceCurrency: "NGN",
    callPriceType: "paid",
    currencies: [],
    description: "",
    hideFromProfile: false,
    isUrlRedirect: false,
    redirectAfterPurchase: "none",
    telegramGroupId: undefined,
    name: "",
    requestCustomerPhoneNumber: false,
    limitUnitsPerTransaction: false,
    purchaseLimit: undefined,
    url_redirect: undefined,
    coverImage: "",
    attendeesType: "limited",
    classSeries: [],
    closeRegistration: false,
    customDuration: undefined,
    duration: "15",
    startDate: moment(new Date()).add(1, "day").format("YYYY-MM-DD"),
    startTime: "09:00 AM",
    attendees: undefined,
    customUrl: undefined,
    topicType: "single",
  },
  apiResponseData: null,
};

export const createLiveEventReducer = (
  state: CreateLiveEventState = initialCreateLiveEventState,
  action: CreateLiveEventActions
) => {
  if (action.type === "update-create-live-event-form-step") {
    const yo = {...state, currentCreateLiveEventStep: action.payload};
    return yo;
  }
  if (action.type === "go-to-basic-form-step") {
    const yo = {
      ...state,
      currentCreateLiveEventStep: "basicForm" as CreateLiveEventSteps,
      formData: {
        ...state.formData,
        ...action.payload,
      },
    };
    return yo;
  }
  if (action.type === "go-to-checkout-form-step") {
    const yo = {
      ...state,
      currentCreateLiveEventStep: "checkoutForm" as CreateLiveEventSteps,
      formData: {
        ...state.formData,
        ...action.payload,
      },
    };
    return yo;
  }
  if (action.type === "go-to-cover-images-upload-form-step") {
    const yo = {
      ...state,
      currentCreateLiveEventStep: "coverImagesUpload" as CreateLiveEventSteps,
      formData: {
        ...state.formData,
        ...action.payload.formData,
      },
      apiResponseData: action.payload.apiResponse,
    };
    return yo;
  }
  if (action.type === "go-to-cohost-form-step") {
    const yo = {
      ...state,
      currentCreateLiveEventStep: "cohost" as CreateLiveEventSteps,
    };
    return yo;
  }
  if (action.type === "save-create-live-event-form-values") {
    return {
      ...state,
      formData: {
        ...state.formData,
        ...action.payload,
      },
    };
  }
  if (action.type === "reset-state") {
    const yo = {...initialCreateLiveEventState};
    return yo;
  }

  return state;
};
